"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsPrioritisationSection = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var PriorityReadinessChart_1 = require("../../../PriorityReadinessChart/PriorityReadinessChart");
var prioritisation_1 = require("../../../shared/utils/prioritisation");
var strategy_selection_1 = require("../../../shared/utils/strategy-selection");
require("./PrioritisationSection.scss");
var MOCK_PRIORITISATION_ENTRIES = [
    {
        strategyId: '101',
        strategyName: 'Customer Self-Service',
        score: 0.82,
    },
    {
        strategyId: '102',
        strategyName: 'Process Automation',
        score: 0.64,
    },
    {
        strategyId: '103',
        strategyName: 'Knowledge Assistant',
        score: 0.27,
    },
];
var normalizeScore = function (score) {
    if (score < 0) {
        return 0;
    }
    if (score > 1) {
        return 1;
    }
    return score;
};
var formatPrioritisationPercent = function (score) {
    var percentage = normalizeScore(score) * 100;
    var rounded = Math.round(percentage * 10) / 10;
    return Number.isInteger(rounded) ? rounded + "%" : rounded.toFixed(1) + "%";
};
var getPrioritisationLevel = function (score) {
    // Range split: 0.00-0.39 low, 0.40-0.69 medium, 0.70-1.00 high.
    if (score >= 0.7) {
        return 'high';
    }
    if (score >= 0.4) {
        return 'medium';
    }
    return 'low';
};
var clampPercent = function (value) {
    if (!Number.isFinite(value)) {
        return 0;
    }
    if (value < 0) {
        return 0;
    }
    if (value > 100) {
        return 100;
    }
    return value;
};
var toReadinessPercentage = function (rawScore) {
    if (typeof rawScore !== 'number' || !Number.isFinite(rawScore)) {
        return null;
    }
    return rawScore >= 0 && rawScore <= 1 ? rawScore * 100 : rawScore;
};
var getReadinessScore = function (useCase) {
    var topLevel = toReadinessPercentage(useCase.readinessScore);
    if (typeof topLevel === 'number') {
        return clampPercent(topLevel);
    }
    // Readiness must come from backend readiness calculation (ready element coverage),
    // never from free-text fields.
    return 0;
};
var toImpactPercentage = function (rawScore) {
    if (typeof rawScore !== 'number' || !Number.isFinite(rawScore)) {
        return 0;
    }
    return clampPercent(rawScore >= 0 && rawScore <= 1 ? rawScore * 100 : rawScore);
};
var WsPrioritisationSection = function (_a) {
    var useCase = _a.useCase, useCases = _a.useCases, strategies = _a.strategies, readinessTotalScore = _a.readinessTotalScore, highlightText = _a.highlightText;
    var _b = react_1.useState(''), selectedStrategyId = _b[0], setSelectedStrategyId = _b[1];
    var visibleStrategies = react_1.useMemo(function () { return strategy_selection_1.filterVisibleStrategies(strategies); }, [strategies]);
    react_1.useEffect(function () {
        if (selectedStrategyId) {
            var strategyStillExists = visibleStrategies.some(function (strategy) { return String(strategy.id) === selectedStrategyId; });
            if (strategyStillExists) {
                return;
            }
        }
        setSelectedStrategyId(visibleStrategies.length > 0 ? String(visibleStrategies[0].id) : '');
    }, [selectedStrategyId, visibleStrategies]);
    var strategyNameById = strategies.reduce(function (result, strategy) {
        result[String(strategy.id)] = strategy.name;
        return result;
    }, {});
    var strategyOptions = react_1.useMemo(function () { return visibleStrategies.map(function (strategy) { return ({ key: String(strategy.id), text: strategy.name }); }); }, [visibleStrategies]);
    var impactAxisLabel = 'READINESS';
    var realEntries = prioritisation_1.getPrioritisationScoreEntries(useCase.fields.Prioritisation)
        .map(function (entry) {
        var _a;
        return ({
            strategyId: entry.strategyId,
            strategyName: (_a = strategyNameById[entry.strategyId]) !== null && _a !== void 0 ? _a : "Strategy " + entry.strategyId,
            score: normalizeScore(entry.score),
        });
    })
        .sort(function (left, right) { return right.score - left.score; });
    var isUsingMockData = false;
    var entries = (isUsingMockData ? MOCK_PRIORITISATION_ENTRIES : realEntries).map(function (entry) { return (__assign(__assign({}, entry), { score: normalizeScore(entry.score) })); });
    var chartUseCases = [
        {
            id: useCase.id,
            title: useCase.title,
            readinessScore: typeof readinessTotalScore === 'number' && Number.isFinite(readinessTotalScore)
                ? clampPercent(readinessTotalScore)
                : getReadinessScore(useCase),
            impactScore: toImpactPercentage(selectedStrategyId
                ? prioritisation_1.getPrioritisationScoreForStrategy(useCase.fields.Prioritisation, selectedStrategyId)
                : null),
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", { className: "ws-ai-hub-prioritisation-title" }, "Prioritisation"),
        react_1.default.createElement("div", { className: "ws-ai-hub-prioritisation-list", role: "list" }, entries.length === 0 ? (react_1.default.createElement("div", { className: "ws-ai-hub-prioritisation ws-ai-hub-prioritisation-empty", role: "listitem" },
            react_1.default.createElement("p", null, "Not prioritised"),
            react_1.default.createElement("h1", null,
                react_1.default.createElement("span", { className: "score" }, "?"),
                react_1.default.createElement("span", { className: "max-score" }, "/1")),
            react_1.default.createElement("p", { className: "ws-ai-hub-prioritisation-desc" }, "UNKNOWN"))) : (entries.map(function (entry) {
            var level = getPrioritisationLevel(entry.score);
            var wrapperClassName = "ws-ai-hub-prioritisation ws-ai-hub-prioritisation-" + level;
            var headingText = entry.strategyName;
            var scoreText = formatPrioritisationPercent(entry.score);
            return (react_1.default.createElement("div", { key: entry.strategyId, className: wrapperClassName, role: "listitem" },
                react_1.default.createElement("p", null, highlightText
                    ? highlightText(headingText, "prioritisation-" + entry.strategyId)
                    : headingText),
                react_1.default.createElement("h1", null,
                    react_1.default.createElement("span", { className: "score" }, scoreText)),
                react_1.default.createElement("p", { className: "ws-ai-hub-prioritisation-desc" }, level.toUpperCase())));
        }))),
        react_1.default.createElement("div", { className: "ws-ai-hub-prioritisation-chart" },
            react_1.default.createElement("div", { className: "ws-ai-hub-prioritisation-chart-controls" },
                react_1.default.createElement(office_ui_fabric_react_1.Dropdown, { label: "Strategy", placeholder: "Select strategy", options: strategyOptions, selectedKey: selectedStrategyId || undefined, onChange: function (_event, option) {
                        setSelectedStrategyId(String((option === null || option === void 0 ? void 0 : option.key) || ''));
                    }, disabled: strategyOptions.length === 0 })),
            react_1.default.createElement(PriorityReadinessChart_1.WsPriorityReadinessChart, { useCases: chartUseCases, highlightedUseCaseId: useCase.id, impactAxisLabel: impactAxisLabel }))));
};
exports.WsPrioritisationSection = WsPrioritisationSection;
